import React from "react";
import { Container } from "react-bootstrap";
import "./Third.css";
import mainImg from "../../../../Asset/Group-290593-1.svg";

const Third = () => {
  return (
    <>
      <section className="third-logistic-section">
        <Container>
          <div className="top-text-services">
            <h2>
              KEY <span> FEATURES</span>
            </h2>
          </div>
          <div className="features_content_part">
            <div className="features_content_warp">
              <div className="row features_content_row">
                <div className="col-xl-4 col-lg-4 col-md-4">
                  <div className="boxs_part">
                    <div className="box_warp">
                      <div className="box">
                        <h3>Predictive Analytics Detail</h3>
                        <p>
                          Forecast shipping trends and optimize inventory
                          management with AI-powered analytics.
                        </p>
                      </div>
                      <div className="box">
                        <h3>IoT Integration Detail</h3>
                        <p>
                          Leverage Internet of Things technology for real-time
                          tracking and condition monitoring.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-4">
                  <div className="img_part">
                    <img src={mainImg} className="w-100" alt="box" />
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-4 ">
                  <div className="boxs_part ">
                    <div className="box_warp">
                      <div className="box">
                        <h3>Scalable Cloud Solutions Detail</h3>
                        <p>
                          Grow your IT capabilities in tandem with your business
                          needs.
                        </p>
                      </div>
                      <div className="box">
                        <h3>24/7 IT Support Detail</h3>
                        <p>
                          Ensure uninterrupted operations with our
                          round-the-clock technical support.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Third;
